import React from 'react';
import type { RatingBlock } from '../../../types/pulse';
import { RatingCue } from '../RatingCue';
interface RatingScreenProps {
  block: RatingBlock;
  value: number | null;
  onChange: (value: number) => void;
}
export function RatingScreen({
  block,
  value,
  onChange
}: RatingScreenProps) {
  return <div className="flex flex-1 flex-col" data-id="element-291" data-mp="225g01spxy4gm">
      <h2 className="font-display text-[21px] font-semibold leading-[1.15] tracking-tight text-navy" data-id="element-292" data-mp="224en1ipd77w9">
        {block.question}
      </h2>
      <p className="mt-3 text-[12.5px] leading-relaxed text-mut" data-id="element-293" data-mp="19g914smkrcuu">{block.support}</p>

      <div className="mt-6" data-id="element-294" data-mp="1eflodehcylxy">
        <RatingCue value={value} onChange={onChange} lowLabel={block.lowLabel} highLabel={block.highLabel} data-id="element-295" data-mp="1efc8wktxvx6i" />
      </div>
    </div>;
}